/**
 * Validates an identifier according to common data warehouse naming conventions
 * @param {string} name - The identifier to validate
 * @param {string} fieldName - The name of the field being validated (e.g. "Table name", "Dataset ID")
 * @returns {string} Empty string if valid, error message if invalid
 */
export const validateIdentifier = (name, fieldName = 'Table name') => {
  if (!name) return `${fieldName} is required`;
  if (name.length > 255) return `${fieldName} must not exceed 255 characters`;
  if (!/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(name)) {
    return `${fieldName} must start with a letter or underscore and can only contain letters, numbers, and underscores.`;
  }
  return '';
};
